import React from 'react';

import SamplesSpecificationsTable from './SamplesSpecificationsTable';

const CategoricalComponent = props =>
  <div className="content-item">
    <div className="flex space-between">
      <p className="font-700 mb-10">
        Summary Table
      </p>
    </div>

    <SamplesSpecificationsTable {...props} />
  </div>;

export default CategoricalComponent;
